<!-- ======= Journals Section ======= -->
<section id="journals" class="journals">

    <div class="container">
        <app-breadcrumb-navigation></app-breadcrumb-navigation>
        <div class="section-title" data-aos="fade-up">
            <h2 tabindex="0">{{'journal.all_journals_main_heading' | translate}}</h2>
            <p tabindex="0">Explore our diverse range of scholarly journals.</p>
        </div>
        <img class=" img-fluid img-rect-left position-absolute ml-1" src="assets/images/Rectangle 501.webp" alt="">
        <!-- ======= Journal cards section ======= -->
        <div class="row d-flex align-items-stretch">

            <div class="col-md-4" *ngFor="let eachJournal of journalData">
                <div class="rvh-journal-card">
                    <img *ngIf="eachJournal.journal_cover_image" class="rvh-journal-cover-img imgClass" tabindex="0"
                        [alt]="eachJournal.journal_cover_alt_text" src="{{imageUrl+eachJournal.journal_cover_image}}">
                    <img *ngIf="!eachJournal.journal_cover_image" class="rvh-journal-cover-img imgClass" src="{{defaultJournalCoverImage}}"
                    tabindex="0"
                    [alt]="'common.default_cover_image'|translate" >
                    <div class="rvh-journal-description-bk"></div>
                    <div class="rvh-journal-logo">
                        <img *ngIf="eachJournal.journal_logo" src="{{imageUrl+eachJournal.journal_logo}}" tabindex="0"
                            [alt]="eachJournal.journal_logo_alt_text" class="logo-image" alt="" routerLink="">
                        <img *ngIf="!eachJournal.journal_logo" src="{{defaultJournalLogo}}" class="logo-image" 
                        [alt]="'common.default_journal_logo'|translate" 
                        tabindex="0"
                            routerLink="">
                    </div>
                    <div class="rvh-journal-description">
                        <div class="rvh-jnl-name" tabindex="0" [innerHTML]="eachJournal.journal_display_name"></div>
                    </div>
                    <div class="rvh-journal-info pt-4">
                        <div><a [routerLink]="['/journal',eachJournal.id,'volumes']" [attr.aria-label]="('site_home.latest_volume_of'|translate)+eachJournal.journal_display_name"
                            class="text-white" role="link" title="{{'site_home.latest_volume'|translate}}">
                                {{'site_home.latest_volume'|translate}}</a></div>
                        <div><a [routerLink]="['/journal',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue]"
                                [attr.aria-label]="('site_home.latest_issue_of'|translate)+eachJournal.journal_display_name" class="text-white"  role="link"
                                title="{{'site_home.latest_issue'|translate}}">
                                {{'site_home.latest_issue'|translate}}
                            </a>
                        </div>
                        <div>
                            <a [routerLink]="[ '/journal',eachJournal.id,'articles',eachJournal.latest_volume,eachJournal.latest_issue,eachJournal.latest_article]"
                                [attr.aria-label]="('site_home.latest_article_of'|translate)+eachJournal.journal_display_name" role="link" title=" {{'site_home.latest_article'|translate}}"
                                class="text-white">
                                {{'site_home.latest_article'|translate}}</a></div>
                    </div>
                    <div class="rvh-journal-socialmedia-icons">
                        <a *ngFor="let media of eachJournal.social_media_links" class="card-sm-icon " [routerLink]="['{{media.value}}']"
                            role="link" aria-label="facebook" title="{{media.label}}">
                            <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                        </a>
                    </div>
                    <div class="rvh-journal-btn">
                        <a [routerLink]="[ '/journal',eachJournal.id]" role="link" title="{{'journal.go_to_journals' | translate}}">{{'journal.go_to_journals' | translate}}</a>
                    </div>
                </div>

            </div>
        </div>
        <!-- ======= End Journal cards section ======= -->
    </div>
</section>
<!-- ======= End Journals Section ======= -->